import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import * as $ from "jquery";

@Component({
    selector: "app-service-details",
    templateUrl: "./service-details.component.html",
    styleUrls: ["./service-details.component.scss"],
})
export class ServiceDetailsComponent implements OnInit {
    info: string;
    infoDetail: string;
    firstTitle: string;
    firstContent: string;
    firstImg: string;
    secondTitle: string;
    secondContent: string;
    secondImg: string;
    textcolor: string;
    thirdTitle: string;
    thirdContent: string;
    thirdImg: string;
    fourthTitle: string;
    fourthContent: string;
    fourthImg: string;

    constructor(private route: ActivatedRoute, private router: Router) {
        this.route.queryParams.subscribe((params) => {
            this.info = params["info"];
        });
        router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                $(".header-title").removeClass("active");
            }
        });
    }

    ngOnInit() {
        $(".header-title:contains(" + this.info + ")").addClass("active");

        if (this.info == "se1") {
            this.info = "SAP 企業流程改造";
            this.textcolor = "rgb(126, 198, 58)";
            this.infoDetail = "帶動企業轉型關鍵，佈局全球未來";
            this.firstTitle = "SAP ERP顧問服務：";
            this.firstContent =
                "<span>碩達系統</span>為 SAP 金級合作夥伴及 SAP PCoE 維護服務認證夥伴，碩達擁有專業且經驗豐富的顧問團隊，協助客戶規劃、整合、自動化企業核心營運流程，檢視組織架構、強化內稽內控，優化核心競爭力。制定有效的導入策略及實施步驟，協助客戶進行 ERP 導入及 Rollout 服務。";
            this.firstImg = "assets/img/services-details/pic_23.jpg";
            this.secondTitle = "SAP BASIS Consultant";
            this.secondContent =
                "<span>方寸之間，自有天地</span>，ERP 是企業重要的核心系統，與所有營運關聯，如何在現有基礎上升級、擴充、加值或是新建、移轉、改善，都需要專業且全面的考量，<span>碩達系統</span>有最專業的導入團隊，兼顧軟硬體整合並且擁有產業專家資源進行諮詢與專案合作，協助企業串連所有價值鏈，攻克趨於複雜化的商業環境。<br><br><span>旗艦領航 全球策略：</span><ul><li>SAP 資訊架構導入或升級規劃評估</li><li>SAP ERP 系統導入及 Rollout 服務</li><li>ABAP 委外服務</li><li>SAP 顧問諮詢服務</li><li>SAP 實體、虛擬環境或雲端解決方案</li><li>高可用及災害備援規劃方案</li><li>SAP 平台移轉方案規劃<ul><li>UNIX 轉 Linux (U2L)</li><li>實體轉虛擬(P2V)</li><li>地面轉雲端(P2C)</li></ul></li><li>SAP IT 環境維運及技術支援</li>";
            this.secondImg = "assets/img/services-details/pic_24.jpg";
        } else if (this.info == "se2") {
            this.info = "軟體定義資訊中心";
            this.textcolor = "#2781bd";
            this.infoDetail = "IT 資訊部門最佳戰友";
            this.firstTitle = "市場概況：";
            this.firstContent =
                "2020年，全球軟體定義數據中心（SDDC）市場價值為 425.5 億美元，預計 2026 年將達到 1572.4 億美元，複合年增長率為 26.6％。<br><ul><li><span>使用軟體定義數據中心的原因： </span><ul><li>市場驅動因素：雲服務採用率激增</li><li>市場趨勢：對更高頻寬和低延遲的需求不斷增長</li><li>市場挑戰：例如，減少的資本和營運支出、有效的災難恢復以及較高的運算能力、COVID-19 後企業對於彈性應用的重視</li></ul></li><li>什麼是SDDC (Software Defined Data Center)：<br>運行範圍從很小的”微型設備”和”邊緣運算”到龐大的”超大規模數據中心”，透過中間數據層的伺服器串聯實現可能，而SDDC主要包含三個面向： <ul><li>軟體定義的網絡（SDN）</li><li>軟體定義的存儲（SDS）</li><li>軟體定義的計算（SDC）</li></ul></li></ul>";
            this.firstImg = "assets/img/services-details/pic_25.jpg";
            this.secondTitle = "易窮則變 & 變則通達";
            this.secondContent =
                "IDC 全球研究部副總裁 Richard Villars 說：“在可預見的未來，雲將在 IT 行業中發揮更大的作用，甚至起主導作用。”  “到 2021 年底，根據大流行的經驗教訓，大多數企業將建立一種機制，加速過渡到以雲為中心的數位基礎架構和應用程式服務。”<span>碩達系統</span>擁有豐富經驗，了解產業特性，兼顧實用與未來發展，協助企業打造下一代資訊系統架構<br><br><span>企業擴展利器，戰力提升法寶：</span><ul><li>實現虛擬化及混和雲的最佳方案</li><li>虛擬化基礎架構 (SDI)</li><li>軟體定義儲存架構　(SDS)</li><li>軟體定義網路架構 (SDN)</li><li>虛擬化桌面雲 (VDI)</li><li>虛擬化容器平台 (K8s)</li><li>自動化佈署 (Deploy)及監控平台 (Monitoring)</li><li>維運管理 (Operation)</li></ul>";
            this.secondImg = "assets/img/services-details/pic_26.jpg";
        } else if (this.info == "se3") {
            this.info = "企業混合雲";
            this.textcolor = "#2781bd";
            this.infoDetail = "打造有效、穩定、彈性、多元的資訊環境";
            this.firstTitle = "從IT到ITSM(資訊科技服務管理)：";
            this.firstContent =
                "要達到新的企業發展架構，需要大量 IT 資訊服務支援，資訊單位的挑戰，不僅要改變與 IT 服務交付和支持有關的傳統工作方式，而且要反映出對企業“更好、更快、更有價值”。<br><br><span>資訊單位面臨挑戰：</span><ul><li>遠距工作支援：穩定連線、資料安全、資源管理、數據中心管理...</li><li>IT 服務台優化：需求申請、服務派送</li><li>自動化流程：減少人為介入，加快服務/需求流程</li><li>AI 智能導入：協助分析、跨組織管理應用</li><li>風險管理：跨平台/應用/組織的風險管理</li><li>業務模式改變：因應業務與營運模式改變，促使 IT 除了維運現有還要引進創新應用，在有限人力下形成強力負擔</li></ul>";
            this.firstImg = "assets/img/services-details/pic_27.jpg";
            this.secondTitle = "攻守兼備 & 服務智囊";
            this.secondContent =
                "“最敏捷的，未必贏得競賽：最強大的，未必贏得戰爭：時間與機會才是主人。”By Solomon，在資訊的世界裡，隨時都有新的方案與技術應用產生，不斷追求最新可能最後成為企業的負擔，<span>碩達系統</span>走在資訊技術的前端，審慎評估每一個發展，針對企業環境提供最適用的方案，致力於成為企業資訊服務最佳夥伴與智囊。<br><br><span>虛實混合，撥雲見日：</span><ul><li>公有, 私有及混合雲架構</li><li>企業資料儲存規劃</li><li>企業災害備援規劃</li><li>虛實管理與優化</li><li>資料加解密及保全規劃</li><li>機房建置與維運</li></ul>";
            this.secondImg = "assets/img/services-details/pic_28.jpg";
            this.thirdTitle = "從工人智慧到人工智慧";
            this.thirdContent =
                "AI 人工智慧與自動化結合議題在企業管理應用探討已久，但近幾年由於網路頻寬、運算設備…等等的技術進步與普及，真正實務應用才有效的展現出來，而在這之前先要完成 &rarr; 簡單化 、標準化、 排程化；進而發展到<br><ul><li>RPA(流程自動化) &rarr; IPA(智能流程自動化)</li><li>RPA 即服務（RPAaaS）</li><li>員工經驗（EX）+ RPA 整合</li><li>RPA+ERP 整合</li></ul>";
            this.thirdImg = "assets/img/services-details/pic_29.jpg";
            this.fourthTitle = "簡單中的不簡單";
            this.fourthContent =
                "<span>碩達系統</span>了解企業在導入新方案的考量與風險，為企業資訊中心提供自動化服務，從整合資訊到簡化流程，讓管理人員可以在第一時間掌握機房資訊，做妥善調度，為企業資訊管理轉型開啟第一步<br><ul><li>服務申請</li><li>服務切換</li><li>資源派送</li><li>快速佈署</li></ul>";
            this.fourthImg = "assets/img/services-details/pic_30.jpg";
        } else if (this.info == "se4") {
            this.info = "資訊專案服務";
            this.textcolor = "rgb(126, 198, 58)";
            this.infoDetail = "專業評估，縱橫發展";
            this.firstTitle = "聯手出擊 戰力進化：";
            this.firstContent =
                "經營業務驅動技術改革勢在必行，針對企業不同需求，資訊團隊除了自我提升提供加值服務外，也需要更多支援加速創新，有鑑於專案項目的複雜性及其對整個企業成功營運的核心意義，長期可信賴的夥伴格外重要，與企業共同參與戰略規劃、風險預防、系統架構設計，並且以滾動式修正計畫，確保方向正確，提供專業建議，減少跨域整合風險；<span>碩達系統</span>擁有專業服務團隊、數十年資訊領域經驗以及國內外合作夥伴，豐富專案執行經歷，將成為您企業發展可靠的戰略夥伴。<br><br><span>服務內容：</span><ul><li>大型專案管理及執行</li><li>整合性資訊維運專案</li><li>敏捷開發及維運 (DevOps)</li><li>資訊中心規劃及建置</li><li>大數據系統導入規劃</li></ul>";
            this.firstImg = "assets/img/services-details/pic_31.jpg";
            this.secondTitle = "誠信至上 專業保障：";
            this.secondContent =
                "企業最佳後盾，<span>碩達系統</span>對於專案服務秉持誠信至上，專業保障的精神，為顧客提供最好服務。<br><br><span>服務團隊與準則：</span><ul><li>專業人才庫：顧問、專案經理、技術支援工程師</li><li>標準化安全協議與作業文件</li><li>專業協調溝通與工作流程掌控</li><li>法律及專案相關顧問團隊支援</li></ul>";
            this.secondImg =
                "assets/img/services-details/動能04_pic_32_sss.png";
        }
    }
}
